import {
  both,
  concat,
  filter,
  find,
  flatten,
  isNil,
  map,
  prop,
  propEq,
  reject,
  uniqBy,
} from 'ramda';

import type { GameGroup } from '@ezugi/types';

import type { LobbyTable } from '../types/table';

/**
 * Sort tables putting the ones from group config `tables` first,
 * then adding tables according to their game id position in group config `games`.
 * This sorting is applied when BO config `tables_sorting_type` is `default`
 */
export const sortTablesByGameId = ({
  groupLiveTables,
  groupConfig,
}: {
  groupLiveTables: LobbyTable[];
  groupConfig: GameGroup;
}): LobbyTable[] => uniqBy(
  prop('id'),
  reject(
    isNil,
    concat(
      map(
        (id) => find(propEq('id', `${id}`))(groupLiveTables),
        groupConfig.tables
      ) as LobbyTable[],
      flatten(
        map(
          (gameId) => filter(
            both(
              propEq('gameId', gameId),
              ({ id }: LobbyTable) => !groupConfig.tables.includes(Number(id))
            )
          )(groupLiveTables),
          groupConfig.games
        )
      )
    )
  )
) as LobbyTable[];
